import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export enum VIDEO_TARGET {
  Global,
  Conversation,
}

export interface VideoOverlay {
  src: string; // Source URL of the video
  targetId: number; // ID of the overlay we want to play the video on
  loop?: boolean; // Whether to loop the video
  stopVideoEarlyMs?: number; // MS to stop video before natural ending
  delayStartMs?: number; // MS to wait before video starts playing
  delayRemovalMs?: number; // MS to wait after video ends before removing overlay
  callback?: Function; // Optional callback to execute after overlay is removed
}

@Injectable({
  providedIn: 'root',
})
export class VideoOverlayService {
  private overlayTrigger: BehaviorSubject<VideoOverlay | undefined> = new BehaviorSubject<VideoOverlay | undefined>(
    undefined,
  );
  constructor() {}

  public getTrigger(): Observable<VideoOverlay | undefined> {
    return this.overlayTrigger.asObservable();
  }

  public startVideoOverlay(videoOverlay: VideoOverlay) {
    this.overlayTrigger.next(videoOverlay);
  }

  public stopVideoOverlay() {
    this.overlayTrigger.next(undefined);
  }
}
